<template>
  <div v-if="call_state != 'MISSED'" class="call-handler">
    <div class="call-handler-contents">
      <h6>{{ call_state }}</h6>
      <div v-if="outboundCall && call_state == 'CONNECTING'">
        <h5>
          Outgoing to: {{ caller_name }}
          <span class="border-box">{{ queue_name }}</span>
        </h5>
      </div>
      <div v-else>
        <h5>
          {{ caller_name }} <span class="border-box">{{ queue_name }}</span>
        </h5>
      </div>
      <h6>
        {{ caller_number }}
        <span :state="time" v-if="call_state == 'CONNECTED'"
          >{{ displayHours }}:{{ displayMinutes }}:{{ displaySeconds }}</span
        >
      </h6>

      <div class="call-handle-buttons-container">
        <b-button
          size="sm"
          @click="OnholdToggleInitialCall()"
          id="tooltip-target-hold"
          pill
          v-b-tooltip.hover.bottom
          :title="hold_status?'Play':'Hold'"
          class="call-control-buttons"
          :variant="hold_status ? 'primary' : 'secondary'"
          :disabled="
            call_state ? call_state == 'CONNECTING' : call_state != 'CONNECTING'
          "
        >
          <font-awesome-icon :icon="hold_status ? 'play' : 'pause'" size="sm" />
        </b-button>
        <!-- <b-tooltip
          target="tooltip-target-hold"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Hold/Play</b-tooltip
        > -->

        <b-button
          size="sm"
          @click="OnMuteToggle()"
          id="tooltip-target-mute"
          pill
          v-b-tooltip.hover.bottom
          :title="mute_status? 'Unmute' : 'Mute'"
          class="call-control-buttons"
          :variant="mute_status ? 'primary' : 'secondary'"
          :disabled="
            call_state ? call_state == 'CONNECTING' : call_state != 'CONNECTING'
          "
        >
          <font-awesome-icon
            :icon="mute_status ? 'microphone-alt' :'microphone-alt-slash'"
            size="sm"
          />
        </b-button>
        <!-- <b-tooltip
          target="tooltip-target-mute"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Mute</b-tooltip
        > -->

        <b-button
          size="sm"
          @click="OnQuickTransfer()"
          id="tooltip-target-qc"
          pill
          class="call-control-buttons"
          variant="secondary"
          :disabled="
            call_state ? call_state == 'CONNECTING' : call_state != 'CONNECTING'
          "
        >
          <font-awesome-icon icon="random" size="sm" />
        </b-button>
        <b-tooltip
          target="tooltip-target-qc"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Quick Connect</b-tooltip
        >

        <b-button
          size="sm"
          @click="OnDialPadToggle()"
          id="tooltip-target-dp"
          pill
          class="call-control-buttons"
          variant="secondary"
        >
          <font-awesome-icon icon="th" size="sm" />
        </b-button>
        <b-tooltip
          target="tooltip-target-dp"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Number Pad</b-tooltip
        >
        <!-- <b-button
          size="sm"
          @click="addManualLog()"
          id="tooltip-target-mn"
          pill
          class="call-control-buttons"
          variant="secondary"
        >
          <font-awesome-icon icon="book" size="sm" />
        </b-button>
        <b-tooltip
          target="tooltip-target-mn"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Manual Logs</b-tooltip
        > -->
        <b-button
          size="sm"
          @click="addManualNotes()"
          id="tooltip-target-ml"
          pill
          class="call-control-buttons"
          variant="secondary"
        >
          <font-awesome-icon icon="sticky-note" size="sm" />
        </b-button>
        <b-tooltip
          target="tooltip-target-ml"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >Add Notes</b-tooltip
        >

        <b-button
          @click="OnEndIntialCall()"
          id="tooltip-target-ec"
          class="call-control-buttons"
          size="sm"
          pill
          variant="danger"
        >
          <font-awesome-icon icon="phone-slash" size="sm" />
        </b-button>

        <b-tooltip
          target="tooltip-target-ec"
          triggers="hover"
          :noninteractive="true"
          placement="bottom"
          >End Call</b-tooltip
        >
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import store from "../../../store";
import { mapGetters } from "vuex";
import "amazon-connect-streams";
import "amazon-connect-chatjs";
import {
  onholdToggleInitialCall,
  onMuteToggle,
  onEndIntialCall,
} from "../../../lib/CallActions.js";

import Dialer from "../../Dialer/index.vue";

export default {
  name: "IncomingCall",
  data() {
    return {
      pageUrl: "home",
    };
  },
  components: {
    Dialer,
  },
  methods: {
    OnholdToggleInitialCall() {
      onholdToggleInitialCall();
    },
    OnMuteToggle() {
      
        onMuteToggle(this.mute_status);
     
    },
    OnDialPadToggle() {
      this.$store.dispatch('actions/callSubNavigation', 'dialpad')
      // this.$store.dispatch("call/updateNumberPad", true);
      this.$store.dispatch("call/updateNotesEditor", false);

    },
    OnQuickTransfer() {
      if(this.number_pad){
        this.$store.dispatch("call/updateNumberPad", false);
      }
      if(this.notes_editor){
        this.$store.dispatch("call/updateNotesEditor", false);
      }
      this.$store.dispatch("actions/callSubNavigation", "quickconnects");
    },
    addManualNotes() {
      this.$store.dispatch("call/updateNotesEditor", true);
      this.$store.dispatch("call/updateNumberPad", false);

    },
    OnEndIntialCall() {
      if(this.number_pad){
        this.$store.dispatch("call/updateNumberPad", false);
      }
      if(this.notes_editor){
        this.$store.dispatch("call/updateNotesEditor", false);
      }
      onEndIntialCall();
    },
    // callerName() {
    //   if (this.caller_name == 'Unknown Caller') {
    //     return (this.caller_name = 'Calling...')
    //   } else {
    //     return this.caller_name
    //   }
    //},
    showRemaining() {
      const timer = setInterval(() => {
        const startTime = new Date(this.start_time).getTime();
        const endTime = new Date(this.end_time).getTime();
      });
    },
    addManualLog() {
      let passData = {};
      passData.action = "ADD_MANUAL_LOGS";
      passData.agentId = store.getters.agent_username;
      passData.contactId = store.getters.contact_id;
      passData.callerName = store.getters.caller_name;
      passData.callerName = store.getters.caller_name;
      passData.callerNumber = store.getters.caller_number;
      passData.callerId = store.getters.caller_id;
      // passData.start_time = store.getters.start_time;
      // passData.end_time = store.getters.end_time;
      // passData.callDuration = store.getters.callDuration;
      passData.callType = store.getters.fs_call_type;
      passData.calledTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
      // passData.DestroyedFlag = store.getters.on_destroyed_flag;
      console.log(passData);
      parent.postMessage(passData, "*");
    },
  },
  computed: {
    ...mapGetters([
      "call_state",
      "caller_name",
      "queue_name",
      "caller_number",
      "mute_status",
      "hold_status",
      "start_time",
      "end_time",
      "displayHours",
      "displayMinutes",
      "displaySeconds",
      "outboundCall",
      "number_pad",
      "notes_editor"
    ]),
    time() {
      if (this.call_state == "CONNECTED") {
        function startTime() {
          this.displaySeconds += 1;
        }
        setInterval(startTime, 1000);
      }
    },
  },
};
</script>

<style scoped>
.border-box {
  border: 1px solid grey;
  border-radius: 0.77rem;
  color: rgb(0, 0, 0);
  font-size: 0.75rem;
  padding: 0 0.35rem;
  background-color: #aaacad;
}
.call-handle-buttons {
  width: 110px;
  margin: 0 5px;
}

.call-handler {
  display: table;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.call-handler-contents {
  display: table-cell;
  margin: 0;
}

.call-control-buttons {
  margin: 0 0.85rem 0 0;
}

.call-handle-buttons {
  width: 110px;
  margin: 0 5px;
}

.call-handle-buttons-container {
  margin-left: 0.6rem;
  margin-bottom: 0.5rem;
}
</style>
